export const DISABLED_EXPORT_BUTTON_MESSAGE = "Export action disabled per your clinic's preference";
